import React from 'react'
import { Component } from 'react';
import '../css/BisharatMain.css'
import {  MaaloulHistoryZakrat } from '../data/Text/mainText.js';
import translate from '../languages/translate';

class  FamilyHistory extends Component {

  state = {
    selectedPar : [] 
  }

  componentDidMount() {
    this.setState({ selectedPar: MaaloulHistoryZakrat });
}

 
  handleSelectorCollectionAlbum( collection) {
    this.setState({selectedPar : collection})
  }

  render() {


  return (

    <div className="top-level-page-main family-history">
      <div className="history-article">
      <div>
      <h1> {translate("historical-info")} </h1>

       
      {/* <button className="btn" onClick = {() => (this.handleSelectorCollectionAlbum(MaaloulHistory))}>{translate("maaloul-village")}   </button>  */}
      {/* <button className="btn" onClick = {() => (this.handleSelectorCollectionAlbum(MaaloulHistoryZakrat))}> {translate("maaloul-village-zochrot")}  </button>  */}
       </div> 
        <div>
     
     
        {this.state.selectedPar} <br/>
          
        </div>
        </div>
      
</div>
   

  )
}};

export default FamilyHistory
